export enum FilterPanelTabValues {
  BUILD = 'build-a-segment',
  RECOMMENDED = 'recommended-segments',
  TEAM_SEGMENTS = 'team-segments',
  TEAM_LISTS = 'team-lists',
}
